"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginQueueItem = void 0;
const tslib_1 = require("tslib");
class PluginQueueItem {
    constructor(resolve, reject, request, method, options, args) {
        this.options = {};
        this.resolve = resolve;
        this.reject = reject;
        this.method = method;
        this.request = request;
        this.timer = undefined;
        this.timedout = false;
        this.canceled = false;
        this.finished = false;
        this.running = false;
        this.args = args;
        this.options = options;
    }
    setCurrentRequest(request) {
        throw new Error('Cannot call this directly');
    }
    callMethod(method, args) {
        throw new Error('Cannot call this directly');
    }
    letContinue() {
        throw new Error('Cannot call this directly');
    }
    cancel() {
        this.canceled = true;
        clearTimeout(this.timer);
        this.reject(`[CANCEL] Canceled call ${this.method} from ${this.request.from}`);
        if (this.running)
            this.letContinue();
    }
    run() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.canceled) {
                this.letContinue();
                return;
            }
            this.timer = setTimeout(() => {
                this.timedout = true;
                this.reject(`[TIMEOUT] Timeout for call ${this.method} from ${this.request.from}`);
                this.letContinue();
            }, this.options.queueTimeout || 10000);
            this.running = true;
            this.setCurrentRequest(this.request);
            try {
                const result = yield this.callMethod(this.method, this.args);
                if (this.timedout || this.canceled)
                    return;
                this.resolve(result);
            }
            catch (err) {
                this.reject(err);
            }
            this.finished = true;
            this.running = false;
            clearTimeout(this.timer);
            this.letContinue();
        });
    }
}
exports.PluginQueueItem = PluginQueueItem;
//# sourceMappingURL=queue.js.map